import { render, staticRenderFns } from "./AppLeftMenu.vue?vue&type=template&id=15fbe448&scoped=true&"
import script from "./AppLeftMenu.vue?vue&type=script&lang=js&"
export * from "./AppLeftMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbe448",
  null
  
)

export default component.exports